import React from 'react';
import { Select } from '@/shared/components/ui';
import { useChannelsDropdown } from '@/modules/channels/hooks/useChannelsDropdown';

/**
 * ChannelSingleSelect Component
 * Single-select dropdown for selecting a channel (Select shared — nunca `<select>` nativo)
 */
interface ChannelSingleSelectProps {
  selectedChannelId: string;
  onSelectionChange: (channelId: string) => void;
  placeholder?: string;
  'data-testid'?: string;
}

const ChannelSingleSelect: React.FC<ChannelSingleSelectProps> = ({
  selectedChannelId,
  onSelectionChange,
  placeholder = 'Selecione um canal...',
  'data-testid': dataTestId = 'channel-single-select',
}) => {
  const { data: channels, isLoading } = useChannelsDropdown();

  if (isLoading) {
    return (
      <Select
        disabled
        value=""
        options={[]}
        placeholder="Carregando canais..."
        data-testid={dataTestId}
      />
    );
  }

  return (
    <Select
      value={selectedChannelId}
      onChange={onSelectionChange}
      placeholder={placeholder}
      options={(channels ?? []).map((channel) => ({ value: channel.id, label: channel.name }))}
      data-testid={dataTestId}
    />
  );
};

export type { ChannelSingleSelectProps };
export { ChannelSingleSelect };
